import { FC } from 'react';
import AccountSetting from './AccountSetting';
import UseAccountSetting from './UseAccountSetting';

const UseAccountSettingContainer: FC = () => {
  return <AccountSetting {...UseAccountSetting()} />;
};

export default UseAccountSettingContainer;
